import type { NonDeprecatedMortgageProductFeeType } from '../mapFeeTypeToCanBeAddedToLoan'

export const mapFeeTypeToFeeTiming: { [key in NonDeprecatedMortgageProductFeeType]: MortgageProductFeeTiming } = {
  ADMINISTRATION_FEE: 'UP_FRONT',
  APPLICATION_FEE: 'UP_FRONT',
  ARRANGEMENT_FEE: 'UP_FRONT',
  ASSESSMENT_FEE: 'UP_FRONT',
  BOOKING_FEE: 'UP_FRONT',
  BROKER_FEE: 'UP_FRONT',
  CHAPS_TELEGRAPHIC_TRANSFER_FEE: 'UP_FRONT',
  COMPLETION_FEE: 'COMPLETION_TIMING',
  DEEDS_RELEASE_FEE: 'REDEMPTION',
  LEGAL_FEE: 'UP_FRONT',
  EARLY_REPAYMENT_CHARGE: 'EARLY_REDEMPTION',
  HIGHER_LENDING_CHARGE: 'UP_FRONT',
  VALUATION_FEE: 'UP_FRONT',
  INSURANCE_ADMINISTRATION: 'UP_FRONT',
  LAND_REGISTRY_FEE: 'UP_FRONT',
  LENDER_CONVEYANCING_FEE: 'UP_FRONT',
  MASTER_BROKER_FEE: 'UP_FRONT',
  MORTGAGE_ACCOUNT_FEE: 'UP_FRONT',
  OTHER_FEE: 'UP_FRONT',
  PACKAGER_FEE: 'UP_FRONT',
  PRODUCT_TRANSFER_FEE: 'UP_FRONT',
  RE_INSPECTION_FEE: 'UP_FRONT',
  REDEMPTION_ADMIN_FEE: 'REDEMPTION',
  TITLE_DEEDS_ADMIN_FEE: 'UP_FRONT',
  INVALID_FEE_TYPE: 'INVALID_TIMING',
  CLAWBACK_FEE: 'EARLY_REDEMPTION',
}
